export const init = () => {
  if (document.querySelector('.b-grid-item-type1__caption')) {
    const wrappers = document.querySelectorAll('.b-grid-item-type1__caption');
    wrappers.forEach((wrapper) => {
      const links = wrapper.querySelectorAll('a[href*="http"]');
      links.forEach((item) => {
        if (window.location.hostname != item.hostname) {
          const elem = document.createElement('span');
          elem.classList.add('external-link');
          item.appendChild(elem);
        }
      });
    })
  }
} 